const digest = '4aea39e40ece4b419cfaabdf129d668406c7e71e141a7b44255fc1bb794e813d';
const css = `._table_1793c_1{border-collapse:collapse;margin-bottom:16px;margin-top:16px;width:100%}._cell_1793c_8{border:1px solid #000;padding:8px}._topAlignedCell_1793c_13{vertical-align:top}._emailLink_1793c_17{text-decoration:underline}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'table': '_table_1793c_1', 'cell': '_cell_1793c_8', 'topAlignedCell': '_topAlignedCell_1793c_13', 'emailLink': '_emailLink_1793c_17' };
export const table = '_table_1793c_1';
export const cell = '_cell_1793c_8';
export const topAlignedCell = '_topAlignedCell_1793c_13';
export const emailLink = '_emailLink_1793c_17';
export { css, digest };